import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp'; // Imported correctly

const JulieCam = ({ user, goBack, goHome }) => { // Add goBack and goHome props
  const [streamId, setStreamId] = useState('x2yU2KF1GuY');
  // eslint-disable-next-line no-unused-vars
  const [cardDescription, setCardDescription] = useState('Live stream unavailable');
  const [membershipType, setMembershipType] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: streamData, error: streamError } = await supabase
          .from('stream_config')
          .select()
          .eq('id', 1)
          .single();
        if (streamError) {
          console.error('Stream fetch error:', streamError.message);
        } else if (streamData) {
          setStreamId(streamData.stream_id || 'x2yU2KF1GuY');
          setCardDescription(streamData.card_description || 'Live stream unavailable');
        }

        const userId = user?.id;
        console.log('User ID:', userId);
        if (userId) {
          const { data: profileData, error: profileError } = await supabase
            .from('user_profiles')
            .select('membership_type')
            .eq('id', userId)
            .single();
          if (profileError) {
            console.error('Profile fetch error:', profileError.message);
          } else if (profileData) {
            setMembershipType(profileData.membership_type);
            console.log('Membership Type:', profileData.membership_type);
          }
        } else {
          console.warn('No user ID available, membership not fetched');
          const { data: { user: authUser } } = await supabase.auth.getUser();
          if (authUser?.id) {
            const { data: profileData, error: profileError } = await supabase
              .from('user_profiles')
              .select('membership_type')
              .eq('id', authUser.id)
              .single();
            if (profileError) {
              console.error('Auth profile fetch error:', profileError.message);
            } else if (profileData) {
              setMembershipType(profileData.membership_type);
              console.log('Fetched Membership Type:', profileData.membership_type);
            }
          }
        }
      } catch (err) {
        console.error('Unexpected error:', err.message);
      }
    };
    fetchData();
  }, [user?.id]);

  // Support both direct video ID and live channel stream
  const streamUrl = streamId.startsWith('live_stream?channel=')
    ? `https://www.youtube.com/embed/${streamId}`
    : `https://www.youtube.com/embed/${streamId}?autoplay=1`;

  const containerStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    width: '100vw',
    margin: '0 auto',
    padding: '16px',
    color: '#fff',
    position: 'relative',
    overflowX: 'hidden',
  };

  // eslint-disable-next-line no-unused-vars
  const buttonStyle = {
    backgroundImage: `url(${buttonImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: '2px solid black',
    borderRadius: '10px',
    padding: '12px 24px',
    width: '100%',
    maxWidth: '120px',
    fontFamily: 'Times New Roman, Times, serif',
    fontSize: 'clamp(14px, 2vw, 16px)',
    fontWeight: 'bold',
    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
    outline: 'none',
    cursor: 'pointer',
  };

  const iframeStyle = {
    width: '100vw',
    maxWidth: '100%',
    height: 'calc(100vh - 100px)',
    border: 'none',
    display: ['Monthly Subscription', 'Yearly Subscription', 'Gift Subscription', 'Admin'].includes(membershipType) ? 'block' : 'none',
  };

  const cardStyle = {
    width: '80%',
    maxWidth: '800px',
    margin: '0 auto',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: '2px solid #fff',
    borderRadius: '10px',
    padding: '20px',
    textAlign: 'center',
    position: 'relative',
  };

  const buttonContainerStyle = {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    width: '100%',
    maxWidth: '768px',
    margin: '20px auto 10px',
  };

  // Media query for mobile to match good version with aspect ratio
  const mediaStyles = `
    @media (max-width: 768px) {
      .container {
        padding: 5px;
      }
      .card {
        width: 90%;
        padding: 10px;
      }
      .iframe {
        width: 100% !important;
        height: calc(100% * 9 / 16) !important;
        min-height: 200px !important;
      }
      .buttons {
        margin-top: 20px;
      }
    }
  `;
  const styleSheet = document.styleSheets[0] || document.head.appendChild(document.createElement('style')).sheet;
  styleSheet.insertRule(`body { margin: 0; padding: 0; }`, styleSheet.cssRules.length); // Ensure no body overrides
  styleSheet.insertRule(`.container { ${Object.entries(containerStyle).map(([k, v]) => `${k}: ${v}`).join(';')} }`, styleSheet.cssRules.length);
  styleSheet.insertRule(`.card { ${Object.entries(cardStyle).map(([k, v]) => `${k}: ${v}`).join(';')} }`, styleSheet.cssRules.length);
  styleSheet.insertRule(`.iframe { ${Object.entries(iframeStyle).map(([k, v]) => `${k}: ${v}`).join(';')} }`, styleSheet.cssRules.length);
  styleSheet.insertRule(`.buttons { ${Object.entries(buttonContainerStyle).map(([k, v]) => `${k}: ${v}`).join(';')} }`, styleSheet.cssRules.length);
  styleSheet.insertRule(mediaStyles, styleSheet.cssRules.length);

  return (
    <div style={containerStyle} className="container">
      <h1 style={{ textAlign: 'center' }}>JulieCam</h1>
      {membershipType === 'Free Subscription' && (
        <p style={{ textAlign: 'center', fontStyle: 'italic', color: '#000' }}>(Upgrade to Monthly or Yearly Subscription on the MyAccount page to view Live Streams when they are available)</p>
      )}
      {['Monthly Subscription', 'Yearly Subscription', 'Gift Subscription', 'Admin'].includes(membershipType) ? (
        <div style={cardStyle} className="card">
          <iframe
            title="JulieCam Live"
            src={streamUrl}
            style={iframeStyle}
            className="iframe"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      ) : (
        <div style={cardStyle} className="card">
          <p style={{ color: '#000' }}>This live stream is available only to paid members or admins. Please upgrade your membership or verify your admin status.</p>
        </div>
      )}
      {/* Navigation Buttons */}
      <div
        className="honor-nav-btn-row"
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          marginTop: '32px',
          marginBottom: '16px',
        }}
      >
        <button
          style={{
            backgroundImage: `url(${buttonImage})`,
            backgroundSize: 'cover',
            border: '2px solid black',
            borderRadius: '10px',
            padding: '10px 20px',
            width: '120px',
            fontFamily: 'Times New Roman, Times, serif',
            fontSize: '16px',
            fontWeight: 'bold',
            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
          }}
          onClick={goBack} // Use prop directly
        >
          Back
        </button>
        <button
          style={{
            backgroundImage: `url(${buttonImage})`,
            backgroundSize: 'cover',
            border: '2px solid black',
            borderRadius: '10px',
            padding: '10px 20px',
            width: '120px',
            fontFamily: 'Times New Roman, Times, serif',
            fontSize: '16px',
            fontWeight: 'bold',
            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
          }}
          onClick={goHome} // Use prop directly
        >
          Home
        </button>
        <button
          style={{
            backgroundImage: `url(${buttonImage})`,
            backgroundSize: 'cover',
            border: '2px solid black',
            borderRadius: '10px',
            padding: '10px 20px',
            width: '120px',
            fontFamily: 'Times New Roman, Times, serif',
            fontSize: '16px',
            fontWeight: 'bold',
            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
          }}
          onClick={() => window.open('https://www.youtube.com/channel/UCdHtXsgozECbQh2JTER8pLg', '_blank')}
        >
          Last Live
        </button>
      </div>
    </div>
  );
};

export default JulieCam;